(function() {
  'use strict';
  
  const ComboBundleIngredients = {
    modal: null,
    modalTitle: null,
    modalContent: null,
    productsList: null,
    focusedElementBeforeModal: null,
    
    init: function() {
      this.modal = document.getElementById('ingredientsModal');
      this.modalTitle = document.getElementById('modalProductTitle');
      this.modalContent = document.getElementById('modalIngredientsContent');
      this.productsList = document.getElementById('bundleProductsList');
      
      if (!this.modal || !this.modalTitle || !this.modalContent || !this.productsList) {
        return;
      }
      
      this.bindEvents();
    },
    
    bindEvents: function() {
      const self = this;
      
      // Delegate click events for ingredient buttons
      this.productsList.addEventListener('click', function(e) {
        const button = e.target.closest('.combo-bundle-ingredients-btn');
        if (button) {
          e.preventDefault();
          const productTitle = button.getAttribute('data-product-title');
          const productIngredients = button.getAttribute('data-product-ingredients');
          self.openModal(productTitle, productIngredients);
        }
      });
      
      // Close modal on overlay click or close button
      const closeElements = this.modal.querySelectorAll('[data-modal-close]');
      closeElements.forEach(function(element) {
        element.addEventListener('click', function() {
          self.closeModal();
        });
      });
      
      // Close modal on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && self.modal.classList.contains('is-open')) {
          self.closeModal();
        }
      });
      
      // Trap focus within modal
      this.modal.addEventListener('keydown', function(e) {
        self.handleTabKey(e);
      });
    },
    
    openModal: function(title, ingredients) {
      // Store currently focused element
      this.focusedElementBeforeModal = document.activeElement;
      
      // Set title
      this.modalTitle.textContent = title || 'All Ingredients';
      
      // Decode HTML entities and set as innerHTML to render HTML formatting
      const decodedIngredients = this.decodeHTML(ingredients);
      
      if (decodedIngredients) {
        // Check if content contains HTML tags
        if (this.containsHTML(decodedIngredients)) {
          // Render as HTML (preserves formatting like <p>, <br>, <strong>, etc.)
          this.modalContent.innerHTML = this.sanitizeHTML(decodedIngredients);
        } else {
          // Plain text - set as textContent
          this.modalContent.textContent = decodedIngredients;
        }
      } else {
        this.modalContent.textContent = 'No ingredients information available.';
      }
      
      // Show modal
      this.modal.classList.add('is-open');
      this.modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      
      // Focus the close button
      const closeBtn = this.modal.querySelector('.combo-bundle-modal-close');
      if (closeBtn) {
        setTimeout(function() {
          closeBtn.focus();
        }, 100);
      }
    },
    
    closeModal: function() {
      this.modal.classList.remove('is-open');
      this.modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('modal-open');
      
      // Clear content when closing
      this.modalContent.innerHTML = '';
      
      // Return focus to the element that triggered the modal
      if (this.focusedElementBeforeModal) {
        this.focusedElementBeforeModal.focus();
      }
    },
    
    decodeHTML: function(html) {
      if (!html) return '';
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },
    
    containsHTML: function(str) {
      // Check if string contains HTML tags
      return /<[a-z][\s\S]*>/i.test(str);
    },
    
    sanitizeHTML: function(html) {
      // Basic sanitization - allow only safe tags for ingredient display
      // Remove potentially dangerous tags and attributes
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;
      
      // Remove script tags
      const scripts = tempDiv.querySelectorAll('script');
      scripts.forEach(function(script) {
        script.remove();
      });
      
      // Remove style tags
      const styles = tempDiv.querySelectorAll('style');
      styles.forEach(function(style) {
        style.remove();
      });
      
      // Remove onclick and other event handlers from all elements
      const allElements = tempDiv.querySelectorAll('*');
      allElements.forEach(function(el) {
        // Remove event handler attributes
        const attributes = Array.from(el.attributes);
        attributes.forEach(function(attr) {
          if (attr.name.startsWith('on') || attr.name === 'href' && attr.value.startsWith('javascript:')) {
            el.removeAttribute(attr.name);
          }
        });
      });
      
      return tempDiv.innerHTML;
    },
    
    handleTabKey: function(e) {
      if (e.key !== 'Tab') return;
      
      const focusableElements = this.modal.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      
      const firstFocusable = focusableElements[0];
      const lastFocusable = focusableElements[focusableElements.length - 1];
      
      if (e.shiftKey) {
        if (document.activeElement === firstFocusable) {
          lastFocusable.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastFocusable) {
          firstFocusable.focus();
          e.preventDefault();
        }
      }
    }
  };
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      ComboBundleIngredients.init();
    });
  } else {
    ComboBundleIngredients.init();
  }
  
  // Re-initialize on Shopify section reload (Theme Editor)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.combo-bundle-section')) {
      ComboBundleIngredients.init();
    }
  });
})();
